import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=77a1a54e&"
import script from "./Accessories.vue?vue&type=script&lang=js&"
export * from "./Accessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports